// Unpublished Work © 2022 Deere & Company

import React from 'react';

export const HealthComponent = () => {
    const message = '{"status" : "UP"}';

    return (
        <div>{message}</div>
    );
};
